export { default } from '@shikijs/langs/sass'
